import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_CREDITOPTIONDETAIL,
  DELETE_CREDITOPTIONDETAIL,
  UPDATE_CREDITOPTIONDETAIL,
  ADD_NEW_CREDITOPTIONDETAIL,
} from "./actionType";

import {
  getCreditOptionDetailSuccess,
  getCreditOptionDetailFail,
  deleteCreditOptionDetailSuccess,
  deleteCreditOptionDetailFail,
  updateCreditOptionDetailSuccess,
  updateCreditOptionDetailFail,
  addCreditOptionDetailSuccess,
  addCreditOptionDetailFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveCreditOptionDetailApi,
  getCreditOptionDetailApi,
  updateCreditOptionDetailApi,
  deleteCreditOptionDetailApi,
  addNewCreditOptionDetailApi
} from "../../helpers/backend_helper";

function* getCreditOptionDetail({ payload: creditOptionDetail }) {
  try {
    const response = yield call(getCreditOptionDetailApi, creditOptionDetail);
    yield put(getCreditOptionDetailSuccess(GET_CREDITOPTIONDETAIL, response.data));
  } catch (error) {
    yield put(getCreditOptionDetailFail(GET_CREDITOPTIONDETAIL, error));
  }
}

function* onUpdateCreditOptionDetail({ payload: creditOptionDetail }) {
  try {
    if (creditOptionDetail.setApprove) {
      const response = yield call(approveCreditOptionDetailApi, creditOptionDetail);
      yield put(updateCreditOptionDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateCreditOptionDetailApi, creditOptionDetail);
      yield put(updateCreditOptionDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateCreditOptionDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteCreditOptionDetail({ payload: creditOptionDetail }) {
  try {
    const response = yield call(deleteCreditOptionDetailApi, creditOptionDetail);
    yield put(deleteCreditOptionDetailSuccess({ creditOptionDetail, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteCreditOptionDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewCreditOptionDetail({ payload: creditOptionDetail }) {
  try {
    const response = yield call(addNewCreditOptionDetailApi, creditOptionDetail);
    yield put(addCreditOptionDetailSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addCreditOptionDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetCreditOptionDetail() {
  yield takeEvery(GET_CREDITOPTIONDETAIL, getCreditOptionDetail);
}

export function* watchUpdateCreditOptionDetail() {
  yield takeEvery(UPDATE_CREDITOPTIONDETAIL, onUpdateCreditOptionDetail);
}

export function* watchDeleteCreditOptionDetail() {
  yield takeEvery(DELETE_CREDITOPTIONDETAIL, onDeleteCreditOptionDetail);
}

export function* watchAddNewCreditOptionDetail() {
  yield takeEvery(ADD_NEW_CREDITOPTIONDETAIL, onAddNewCreditOptionDetail);
}

function* creditOptionDetailSaga() {
  yield all([
    fork(watchGetCreditOptionDetail),
    fork(watchDeleteCreditOptionDetail),
    fork(watchUpdateCreditOptionDetail),
    fork(watchAddNewCreditOptionDetail)
  ]);
}

export default creditOptionDetailSaga;
